import { apiClient } from '../client';
import { AdminUser } from '../../types/admin';

export const usersApi = {
  list: () => apiClient.get<{ data: AdminUser[] }>('/api/admin/users'),
  get: (id: number) => apiClient.get<{ data: AdminUser }>(`/api/admin/users/${id}`),
  create: (input: { fullName: string; email: string }) =>
    apiClient.post<{ data: AdminUser }>('/api/admin/users', input),
  update: (id: number, input: { managerId?: number | null; locationId?: number | null; departmentId?: number | null; positionId?: number | null }) =>
    apiClient.patch<{ data: AdminUser }>(`/api/admin/users/${id}`, input),
  activate: (id: number) => apiClient.patch<{ data: { id: number; is_active: boolean } }>(`/api/admin/users/${id}/activate`),
  deactivate: (id: number) => apiClient.patch<{ data: { id: number; is_active: boolean } }>(`/api/admin/users/${id}/deactivate`),
};
